export { ProductTabs } from './ProductTabs';
export * from './ProductTabs.types';
